import React from "react"

import * as l from "../SideBar.module.scss"

const SizingGuide = copy => {
  return (
    <>
      <div className={l.Content__header}>
        <h3>Sizing Guide</h3>
      </div>
      <div
        className={l.Content__wysiwygContent}
        dangerouslySetInnerHTML={{
          __html: copy,
        }}
      />
    </>
  )
}

export default SizingGuide
